'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMaskedinput = require('react-maskedinput');

var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _inputsLocal = require('../inputs.local.css');

var _inputsLocal2 = _interopRequireDefault(_inputsLocal);

var _textLocal = require('./text.local.css');

var _textLocal2 = _interopRequireDefault(_textLocal);

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _label = require('../label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * Base input for handling text entry
 */


var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput() {
    _classCallCheck(this, TextInput);

    return _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).apply(this, arguments));
  }

  _createClass(TextInput, [{
    key: 'setSelection',
    value: function setSelection(start, end) {
      this.input.setSelectionRange(start, end);
    }
  }, {
    key: 'setFocus',
    value: function setFocus() {
      this.input.focus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classNames;

      var displayIcon = void 0;

      if (this.props.icon && typeof this.props.icon === 'string') {
        displayIcon = _react2.default.createElement(_icon2.default, {
          icon: this.props.icon,
          className: (0, _classnames2.default)([_textLocal2.default.icon, _textLocal2.default['iconPosition--' + this.props.iconPosition]]),
          color: 'dark'
        });
      } else if (this.props.icon) {
        displayIcon = this.props.icon.map(function (icon, index) {
          return _react2.default.createElement(_icon2.default, {
            key: icon.icon,
            icon: icon.icon,
            rotate: icon.rotate,
            onClick: icon.onClick,
            onFocus: icon.onFocus,
            onMouseDown: icon.onMouseDown,
            className: _textLocal2.default.icon,
            customStyling: {
              right: index * 15 + 5 + 'px',
              zIndex: 0
            },
            color: 'dark',
            size: icon.size || 'medium'
          });
        });
      }

      var renderLabel = this.props.label && _react2.default.createElement(_label2.default, {
        htmlFor: this.props.name,
        text: this.props.label,
        className: _inputsLocal2.default.label
      });

      var renderRequiredLabel = this.props.required && _react2.default.createElement('span', {
        className: _textLocal2.default.requiredText
      }, this.props.requiredLabel);

      var Input = typeof this.props.mask === 'string' ? _reactMaskedinput2.default : 'input';
      return _react2.default.createElement('div', {
        style: this.props.style,
        className: (0, _classnames2.default)([_inputsLocal2.default.wrapper, this.props.wrapperClassname])
      }, renderLabel, renderRequiredLabel, _react2.default.createElement('span', {
        role: 'form',
        ref: this.props.ref || null,
        onKeyDown: this.props.onKeyDown,
        onBlur: this.props.onBlur,
        onClick: this.props.onClick,
        onFocus: this.props.onFocus,
        className: _textLocal2.default.inputWrap
      }, _react2.default.createElement(Input // eslint-disable-next-line no-return-assign
      , _extends({
        ref: function ref(e) {
          return _this2.input = e;
        },
        mask: this.props.mask,
        autoComplete: this.props.autoComplete,
        autoCorrect: this.props.autoCorrect,
        autoCapitalize: this.props.autoCapitalize,
        autoFocus: this.props.autoFocus,
        className: (0, _classnames2.default)(_inputsLocal2.default.input, _inputsLocal2.default['theme--' + this.props.theme], this.props.className, (_classNames = {}, _defineProperty(_classNames, _inputsLocal2.default['iconPadding--' + this.props.iconPosition], !!this.props.icon), _defineProperty(_classNames, _inputsLocal2.default.postfixPad, !!this.props.postfix), _classNames)),
        'data-auto': this.props.scope + '_' + this.props.name,
        disabled: this.props.disabled,
        id: this.props.id,
        max: this.props.max,
        min: this.props.min,
        maxLength: this.props.maxLength,
        minLength: this.props.minLength,
        name: this.props.name,
        onChange: this.props.onChange,
        placeholder: this.props.placeholder,
        readOnly: this.props.readOnly,
        required: this.props.required,
        type: this.props.type,
        value: this.props.value,
        role: this.props.role
      }, Object.keys(this.props).filter(function (key) {
        return key.indexOf('aria-') === 0;
      }).reduce(function (obj, key) {
        /* eslint-disable-next-line no-param-reassign */
        obj[key] = _this2.props[key];
        return obj;
      }, {}))), displayIcon, this.props.postfix ? _react2.default.createElement('span', {
        className: _textLocal2.default.inputPostfix
      }, this.props.postfix) : null));
    }
  }]);

  return TextInput;
}(_react.Component);

TextInput.displayName = 'UITextInput';
TextInput.defaultProps = {
  autoComplete: null,
  autoCapitalize: null,
  autoCorrect: null,
  autoFocus: null,
  className: null,
  disabled: false,
  icon: null,
  iconPosition: 'postfix',
  id: null,
  label: null,
  max: null,
  maxLength: null,
  min: null,
  minLength: null,
  onBlur: null,
  onClick: null,
  onChange: null,
  onFocus: null,
  onKeyDown: null,
  placeholder: null,
  readOnly: false,
  ref: null,
  required: false,
  requiredLabel: 'Required',
  scope: 'input',
  style: null,
  theme: 'normal',
  type: 'text',
  value: '',
  wrapperClassname: null
};
TextInput.propTypes = {
  /**
   * Static content to render at the end of the input
   */
  postfix: _propTypes2.default.node,

  /**
   * HTML autocomplete attribute
   */
  autoComplete: _propTypes2.default.string,

  /**
   * HTML autocomplete attribute
   */
  autoCapitalize: _propTypes2.default.string,

  /**
   * HTML autocomplete attribute
   */
  autoCorrect: _propTypes2.default.string,

  /**
   * HTML autoFocus attribute
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * Classname appended to input element
   */
  className: _propTypes2.default.string,

  /**
   * Sets disabled state on input
   */
  disabled: _propTypes2.default.bool,

  /**
   * Adds an icon inside of the input. Pass in either icon name as a string, or an array.
   */
  icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),

  /**
   * Determines icon position ('prefix' or 'postfix')
   */
  iconPosition: _propTypes2.default.oneOf(['prefix', 'postfix']),

  /**
   * Unique id for the input
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Unique name for the input
   */
  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Form label to be applied above input
   */
  label: _propTypes2.default.string,

  /**
   * HTML max attribute
   */
  max: _propTypes2.default.number,

  /**
   * HTML maxlength attribute
   */
  maxLength: _propTypes2.default.number,

  /**
   * HTML minlength attribute
   */
  minLength: _propTypes2.default.number,

  /**
   * HTML min attribute
   */
  min: _propTypes2.default.number,

  /**
   * Function called when input is blurred
   */
  onBlur: _propTypes2.default.func,

  /**
   * Function called when change occurs
   */
  onChange: _propTypes2.default.func,

  /**
   * Function called when click event happens
   */
  onClick: _propTypes2.default.func,

  /**
   * Function called when input is focused
   */
  onFocus: _propTypes2.default.func,

  /**
   * Function called on key down when input is focused
   */
  onKeyDown: _propTypes2.default.func,

  /**
   * Default input placeholder
   */
  placeholder: _propTypes2.default.string,

  /** Define the context/scope of where this input is used */
  scope: _propTypes2.default.string,

  /**
   * Pass style objects to be applied to the component wrapper
   */
  style: _propTypes2.default.string,

  /**
   * Field cannot be written to
   */
  readOnly: _propTypes2.default.bool,
  ref: _propTypes2.default.func,

  /**
   * HTML required attribute
   */
  required: _propTypes2.default.bool,

  /**
   * Text to appear above input when input is required
   */
  requiredLabel: _propTypes2.default.string,

  /**
   * For passing in HTML role attribute
   */
  role: _propTypes2.default.string,

  /**
   * A masking string.
   * @see https://github.com/insin/react-maskedinput
   */
  mask: _propTypes2.default.string,

  /**
   * Sets the color theme to resemble a normal or classic input
   */
  theme: _propTypes2.default.oneOf(['classic', 'normal', 'dark']),

  /**
   *  HTML input type. One of ['date', 'email', 'hidden', number', 'password', 'search', 'tel', 'text', 'url',]
   */
  type: _propTypes2.default.oneOf(['date', 'email', 'hidden', 'number', 'password', 'search', 'tel', 'text', 'url']),

  /**
   * Input value
   */
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * Attach a className to the outermost wrapper
   */
  wrapperClassname: _propTypes2.default.string
};
exports.default = TextInput;